import { createElement, PureComponent } from 'react';
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var serviceUrl = {
  individual: 'https://verify.synaps.io',
  corporate: 'https://verify-v3.synaps.io'
};
var Synaps = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Synaps, _React$PureComponent);
  function Synaps() {
    var _this;
    _this = _React$PureComponent.apply(this, arguments) || this;
    _this._listernerMessage = function (_ref) {
      var data = _ref.data;
      if (data.type === 'ready') {
        _this.props.onReady && _this.props.onReady();
      } else if (data.type === 'finish') {
        _this.props.onFinish && _this.props.onFinish();
      }
    };
    return _this;
  }
  var _proto = Synaps.prototype;
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('message', this._listernerMessage);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('message', this._listernerMessage);
  };
  _proto.getUrl = function getUrl() {
    var _this$props = this.props,
      sessionId = _this$props.sessionId,
      service = _this$props.service,
      color = _this$props.color,
      lang = _this$props.lang,
      tier = _this$props.tier,
      withFinishButton = _this$props.withFinishButton,
      baseUrl = _this$props.url;
    var params = {
      session_id: sessionId,
      service: service,
      primary_color: color ? color.primary : undefined,
      secondary: color ? color.secondary : undefined,
      lang: lang || 'en',
      tier: tier || undefined,
      with_finish_button: withFinishButton
    };
    var url = baseUrl || serviceUrl[service];
    return url + "?" + Object.keys(params).reduce(function (acc, key) {
      if (params[key]) {
        acc.push(key + "=" + params[key]);
      }
      return acc;
    }, []).join('&');
  };
  _proto.render = function render() {
    return createElement("iframe", {
      className: this.props.className,
      src: this.getUrl(),
      style: {
        minWidth: 400,
        minHeight: 687
      },
      allow: 'microphone; camera; midi; encrypted-media; usb; ethereum',
      allowFullScreen: true,
      frameBorder: 'none'
    });
  };
  return Synaps;
}(PureComponent);
export default Synaps;